function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "System-Admin",
  transform: "translate(-800.000000, -516.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(813.500000, 520.500000) rotate(-180.000000) translate(-813.500000, -520.500000) translate(800.000000, 517.000000)"
}, React.createElement("path", {
  d: "M17.1499605,4.79351926 L21.9066035,7.95196166 C22.1381215,8.10927872 22.4117338,7.85515117 22.3275454,7.55261837 L21.8750329,5.9552452 L26.7053407,5.9552452 C26.8631939,5.9552452 27,5.81002946 27,5.61640847 L27,3.37766576 C27,3.19614608 26.8737174,3.03882903 26.7053407,3.03882903 L21.8750329,3.03882903 L22.3275454,1.44145586 C22.4117338,1.15102437 22.1381215,0.896896823 21.9066035,1.04211257 L17.1499605,4.21265628 C16.9500132,4.34577072 16.9500132,4.66040483 17.1499605,4.79351926 Z",
  id: "Path",
  transform: "translate(22.000000, 4.500000) scale(-1, 1) translate(-22.000000, -4.500000) "
}))));

const SvgLeftMove = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLeftMove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/left-move.e7ed9f02.svg";
export { ForwardRef as ReactComponent };